import { useEffect } from 'react';
import ApplyResultSample from '@components/common/applyResultSample';
import V1Result from '@components/acca/results/result/applyResult/v1Result';
import { ResultMenuType } from '@components/acca/results/result/resultTab';
import { useMatchProfilesComplete } from '@repository/profiles/useProfile';
import { useGetMatchConfigStatus } from '@repository/match';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useAccaTestResultStore } from '@stores/AccaTestResultStore';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import ApplyResultContent from './applyResultContent';
import Analyzing from './analyzing';
import AnalysisError from './analysisError';
import V3Result from './v3Result';
import { AnalysisType } from '@domain/constant/analysisType';
import { VersionType } from '@domain/constant/acca/VersionType';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';

interface ApplyResultProps {
  resultState: AnalysisType | null;
  setResultState: (resultState: AnalysisType | null) => void;
  version?: VersionType | null;
  resultMenu: ResultMenuType;
}

const ApplyResult = ({ resultState, setResultState, version = 'V2', resultMenu }: ApplyResultProps) => {
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { isAuthorityUser } = useCheckAuthority(userInfo);
  const { isPublicStore } = useResultStore();
  const { data: ProfilesCompleteInfoData } = useMatchProfilesComplete(!isPublicStore);
  const { data: matchingConfig } = useGetMatchConfigStatus(isLogin);
  const accResultSn = useAccaTestResultStore((state) => state.accResultSn);
  const accResult = useAccaTestResultStore((state) => state.accResult);

  useEffect(() => {
    if (accResult) setResultState(accResult.analysisType);
  }, [accResultSn]);

  const getResult = () => {
    //제휴 서비스 가입한 대상자이거나 프로필 기본 완성시 and 추천 서비스 on일 경우 샘플 이미지 X
    if (
      !isPublicStore &&
      !(isAuthorityUser || (ProfilesCompleteInfoData?.profileRequiredCompleteYn && matchingConfig?.matchingConfigYn))
    )
      return <ApplyResultSample version={version} resultMenu={resultMenu} />;

    // V1 결과표
    if (version === 'V1') return <V1Result />;

    //V2 or v3 결과표
    switch (resultState) {
      // 분석 중
      case 'PROGRESS':
        return <Analyzing />;
      // 분석 완료
      case 'COMPLETE':
        if (version === 'V3') return <V3Result requestPage={'check'} />;
        return <ApplyResultContent />;
      // 분석 오류
      case 'FAILED':
        return <AnalysisError />;
      // 없는 결과표
      default:
        return null;
    }
  };

  return getResult();
};

export default ApplyResult;
